import { ErrorBoundary } from "@sentry/react";
import { FallbackRender } from "@sentry/react/build/types/errorboundary";

export const SentryErrorBoundary = ErrorBoundary;
export type SentryFallbackRender = FallbackRender;
